import React from "react";
import { useLang, LANGS } from "../i18n";

export const LangSwitch = ({ dark = false }) => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center gap-1" data-testid="lang-switch">
      {LANGS.map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`text-xs font-bold uppercase tracking-wide px-2 py-1 rounded transition-colors duration-200 ${
            lang === l
              ? dark ? "text-[#CCFF00]" : "text-[#E07A5F]"
              : dark ? "text-white/40 hover:text-white" : "text-black/40 hover:text-black"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};
